module.exports = __webpack_public_path__ + "media/images/success-e101a5e621e4d43fbe93ba416e2ea8e8.png";